// components/ErrorBoundary.js
import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <section className="bg-brandBlue text-white py-20 px-6 text-center font-outfit min-h-screen flex flex-col items-center justify-center">
          <h1 className="text-4xl font-extrabold mb-4 bg-gradient-to-r from-brandGreen to-softGreen bg-clip-text text-transparent">
            Something went wrong
          </h1>
          <p className="text-lg max-w-xl text-white/80 mb-8">
            We're sorry, but an unexpected error occurred. Try refreshing the
            page or coming back later.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-3 bg-gradient-to-r from-brandGreen to-softGreen text-brandBlue font-semibold rounded-xl transition duration-300 hover:opacity-90"
          >
            Refresh Page
          </button>
        </section>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
